import React from "react";
import bind from "memoize-bind";

import { Form, FormControl, CustomerDecorator, FilterGroup } from "lib/index";

export default class CustomersListFilters extends React.PureComponent {
  handleFilterChange(prop, value) {
    this.handleFiltersChange({ [prop]: value });
  }

  handleFiltersChange(data) {
    const { filters, onFiltersChange } = this.props;
    onFiltersChange({
      ...filters,
      ...data,
    });
  }

  render() {
    const { filters, aggregations } = this.props;
    const filterStatusOptions = CustomerDecorator.statuses.map((v) => [
      v,
      `${I18n.humanAttributeName("customer", v)} (${aggregations.status[v] || 0})`,
    ]);
    const authorPlaceOptions = [
      [
        "frontend",
        `${I18n.humanAttributeName("order", "author_place_frontend")} (${aggregations.author_place["frontend"] || 0})`,
      ],
      [
        "partnerapp",
        `${I18n.humanAttributeName("order", "author_place_partnerapp")} (${
          aggregations.author_place["partnerapp"] || 0
        })`,
      ],
    ];
    return (
      <Form>
        <FilterGroup active>
          <div className="u-positionRelative">
            <FormControl.Input
              placeholder={I18n.t("papp.customers.CustomersListView.query_filter")}
              value={filters.query}
              onChange={bind(this.handleFilterChange, this, "query")}
              fluid
              inputClassName="u-paddingRight"
            />
            <FormControl.DeleteRowButton
              hidden={filters.query === null}
              onClick={bind(this.handleFilterChange, this, "query", null)}
            />
          </div>
        </FilterGroup>

        <FilterGroup
          active
          label={I18n.humanAttributeName("customer", "status")}
          enabled={filters.status !== null}
          onClear={bind(this.handleFilterChange, this, "status", null)}
        >
          <FormControl.MultipleCheckbox
            value={filters.status}
            onChange={bind(this.handleFilterChange, this, "status")}
            options={filterStatusOptions}
            grouped
          />
        </FilterGroup>

        <FilterGroup
          active
          label={I18n.humanAttributeName("customer", "created_at")}
          enabled={filters.created_at !== null}
          onClear={bind(this.handleFilterChange, this, "created_at", null)}
        >
          <FormControl.SeparateDateRange
            value={filters.created_at ? [filters.created_at.gte || null, filters.created_at.lte || null] : null}
            onChange={([gte, lte]) => {
              this.handleFilterChange("created_at", { gte, lte });
            }}
          />
        </FilterGroup>

        <FilterGroup
          active
          label={I18n.humanAttributeName("order", "author_place")}
          enabled={filters.author_place !== null}
          onClear={bind(this.handleFilterChange, this, "author_place", null)}
        >
          <FormControl.MultipleCheckbox
            value={filters.author_place}
            onChange={bind(this.handleFilterChange, this, "author_place")}
            options={authorPlaceOptions}
            grouped
          />
        </FilterGroup>
      </Form>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/customers/CustomersListView/CustomersListFilters.jsx